import {
  DoorStickerTemplate,
  FlyerTemplate,
  PolygraphyProductType,
  StickerTemplate,
} from '../../../../../../../services/exports/Constants';

export default {
  title: 'Print Products',
  types: {
    [PolygraphyProductType.Flyer]: {
      name: 'Flyers',
      templates: {
        [FlyerTemplate.One]: '#1 🆕',
        [FlyerTemplate.Two]: '#2  🆕',
        [FlyerTemplate.Three]: '#3',
        [FlyerTemplate.Four]: '#4',
      },
    },
    [PolygraphyProductType.Sticker]: {
      name: 'Stickers',
      templates: {
        [StickerTemplate.One]: '#1 🆕',
      },
    },
    [PolygraphyProductType.DoorSticker]: {
      name: 'Door Stickers',
      templates: {
        [DoorStickerTemplate.One]: '#1 🆕',
        [DoorStickerTemplate.Two]: '#2 🆕',
      },
    },
    [PolygraphyProductType.Custom]: {
      name: 'Custom print products',
    },
  },
  buttons: {
    order: 'New order',
  },
  toasts: {
    failed_to_load_data: 'Failed to load data',
  },
};
